(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eosa-community-directory"] && !Shopify.designMode) return;
  try {
    
  function initializeEosaDirectories(root) {
    root.querySelectorAll('[data-eosa-directory]').forEach(directory => {
      if (directory.dataset.initialized) return;
      const controls = directory.querySelector('[data-directory-search]');
      if (!controls) return;
      directory.dataset.initialized = 'true';
      const input = controls.querySelector('input');
      const cards = Array.from(directory.querySelectorAll('[data-directory-card]'));
      const count = controls.querySelector('[data-directory-count]');
      const empty = directory.querySelector('[data-directory-empty]');
      const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
      const update = () => {
        const query = normalize(input.value);
        let visible = 0;
        cards.forEach(card => {
          card.hidden = !normalize(card.dataset.searchName).includes(query);
          if (!card.hidden) visible++;
        });
        count.textContent = count.dataset.countTemplate.replace('[count]', visible).replace('[total]', cards.length);
        empty.hidden = visible !== 0;
      };
      input.addEventListener('input', update);
      controls.querySelector('[data-directory-clear]').addEventListener('click', () => { input.value = ''; update(); input.focus(); });
      controls.hidden = false;
      update();
    });
  }
  initializeEosaDirectories(document);
  document.addEventListener('shopify:section:load', event => initializeEosaDirectories(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eosa-department-portal"] && !Shopify.designMode) return;
  try {
    
  function initializeDepartmentPortals(root) {
    root.querySelectorAll('[data-department-portal]').forEach(portal => {
      if (portal.dataset.initialized) return;
      const controls = portal.querySelector('[data-portal-search]');
      const input = controls.querySelector('input');
      const cards = Array.from(portal.querySelectorAll('[data-portal-card]'));
      const count = portal.querySelector('[data-portal-count]');
      const empty = portal.querySelector('[data-portal-empty]');
      const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
      const update = () => {
        const query = normalize(input.value);
        let visible = 0;
        cards.forEach(card => {
          card.hidden = !normalize(card.dataset.searchName).includes(query);
          if (!card.hidden) visible++;
        });
        count.textContent = count.dataset.countTemplate.replace('[count]', visible).replace('[total]', cards.length);
        empty.hidden = visible !== 0;
      };
      const reset = () => { input.value = ''; update(); input.focus(); };
      input.addEventListener('input', update);
      controls.querySelector('[data-portal-clear]').addEventListener('click', reset);
      portal.querySelector('[data-portal-reset]').addEventListener('click', reset);
      controls.hidden = false;
      portal.dataset.initialized = 'true';
      update();
    });
  }
  initializeDepartmentPortals(document);
  document.addEventListener('shopify:section:load', event => initializeDepartmentPortals(event.target));

  } catch(e) { console.error(e); }
})();
})();
